// File: src/components/UpgradeModal.jsx
import React from 'react';
import { createPortal } from 'react-dom';
import { useNavigate } from 'react-router-dom';

const UpgradeModal = ({ isOpen, onClose, message }) => {
    const navigate = useNavigate();
    if (!isOpen) return null;

    return createPortal(
        <div style={{ 
            position: 'fixed', inset: 0, zIndex: 99999, 
            display: 'flex', alignItems: 'center', justifyContent: 'center', 
            backgroundColor: 'rgba(0,0,0,0.6)' // Đen mờ 60%, không blur
        }} onClick={onClose}>
            <div 
                onClick={(e) => e.stopPropagation()}
                className="animate-scaleUp"
                style={{ 
                    backgroundColor: 'white', borderRadius: '16px', padding: '32px', 
                    maxWidth: '420px', width: '90%', textAlign: 'center',
                    boxShadow: '0 25px 50px -12px rgba(0, 0, 0, 0.25)',
                    position: 'relative', overflow: 'hidden'
                }}
            >
                {/* Dải màu trang trí */}
                <div style={{ position: 'absolute', top: 0, left: 0, right: 0, height: '6px', background: 'linear-gradient(90deg, #F59E0B, #EF4444)' }}></div>

                <div style={{ 
                    width: '64px', height: '64px', backgroundColor: '#FEF3C7', 
                    borderRadius: '50%', display: 'flex', alignItems: 'center', justifyContent: 'center', 
                    margin: '0 auto 16px auto', color: '#D97706'
                }}>
                    <span className="material-symbols-outlined" style={{ fontSize: '32px' }}>workspace_premium</span>
                </div>

                <h3 style={{ fontSize: '20px', fontWeight: 'bold', color: '#111827', marginBottom: '8px' }}>
                    Giới hạn gói dịch vụ
                </h3>
                <p style={{ fontSize: '14px', color: '#4B5563', marginBottom: '24px', lineHeight: '1.5' }}>
                    {message || "Bạn đã đạt giới hạn của gói hiện tại. Vui lòng nâng cấp để mở khóa tính năng này."}
                </p>

                <div style={{ display: 'flex', flexDirection: 'column', gap: '12px' }}>
                    <button 
                        onClick={() => navigate('/business/upgrade-account')}
                        style={{ 
                            width: '100%', padding: '12px', borderRadius: '8px', border: 'none',
                            background: 'linear-gradient(90deg, #F59E0B, #EF4444)', 
                            color: 'white', fontWeight: 'bold', fontSize: '14px', cursor: 'pointer',
                            boxShadow: '0 4px 6px -1px rgba(245, 158, 11, 0.3)',
                            transition: 'transform 0.2s'
                        }}
                    >
                        Nâng cấp ngay
                    </button>
                    <button 
                        onClick={onClose}
                        style={{ 
                            background: 'transparent', border: 'none', color: '#6B7280', 
                            fontWeight: '600', fontSize: '13px', cursor: 'pointer' 
                        }}
                    >
                        Để sau
                    </button>
                </div>
            </div>
            <style>{`@keyframes scaleUp { from { transform: scale(0.95); opacity: 0; } to { transform: scale(1); opacity: 1; } } .animate-scaleUp { animation: scaleUp 0.2s ease-out; }`}</style>
        </div>,
        document.body
    );
};

export default UpgradeModal;